import Model from 'lib/Model';
import config from 'config/index.js';
import Turf from 'lib/Turf';


export default Model.extend({

	isActive: function()
	{
		return this.get('is_active');
	},

	contains: function( position )
	{
		var point = { type: "Point", coordinates: [ position.lng, position.lat ] };

		var geojson = this.get('geojson');
		if( geojson.type == "MultiPolygon" )
		{
			return _.some( geojson.coordinates, function( polygon )
			{
				return Turf.booleanContains( { type: "Polygon", coordinates: polygon }, point );
			})
		}

		return Turf.booleanContains( geojson, point );
	},


	// Distance entre une position et le département
	distance: function( position )
	{
		// Si dedans, alors
		if( this.contains( position ) )
		{
			return 0;
		}

		try
		{
			var point = { type: "Point", coordinates: [ position.lng, position.lat ] };
			var explode = Turf.explode( this.get('geojson') );
			var nearest = Turf.nearestPoint( point, explode );
			return Turf.distance( point, nearest );
		}
		catch(e)
		{
			return Infinity;
		}
	},
});
